import { BaseListComponent } from 'src/app/shared/components/base-list-component/base-list-component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { AuthService } from './../../../shared/services/auth.service';
import { Component, Injector } from '@angular/core';
import { Size } from '../models/size.model';
import { SizeService } from '../services/size.service';

@Component({
  selector: 'ng-size-list',
  templateUrl: 'size-list.component.html'
})
export class SizeListComponent extends BaseListComponent<Size> {

   constructor(
    public sizeServ:SizeService,
    public injector:Injector,
    public auth:AuthService,
    public toastr:ToastrManager,
  ){
    super(sizeServ, injector, 'size', {editUrl:'/admin/settings/size/edit', createUrl:'/admin/settings/size/new'});
  }
 
  protected tableProprieties(): string[] {
    return [
        'Código',
        'Tamanho', 
        'Descrição' 
    ]
  }

  protected initChildMethods(): void {}
  protected initChildProprieties(): void {}
  

}
